module.exports = __webpack_public_path__ + "static/media/student-snapshort1-01.00789dd7.png";